module.exports = __webpack_public_path__ + "static/fonts/NotoSans-Regular.0589d1a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/fonts/NotoSans-Regular.eot?
// module id = fQXa
// module chunks = 0